import { Tabs } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import store from "../../../../context/store/store";
import EditMeeting from "../editMeeting";
//import MeetingDetailsRight from "../meetingDetailsRight";
//import MeetingDetailsLeft from "../meetingDetailsLeft";
//import MeetingDetailsRight from "../meetingDetailsRight";
import MeetingDetailsTop from "../meetingDetailsTop";
import MeetingSchedule from "../meetingSchedule";
import SavedTemplateViewList from "../savedTemplate/savedtemplategridview";
import styles from "./schedulemeeting.module.scss";

export default function ScheduleMeetingScreen() {
  const { TabPane } = Tabs;
  let { currentWindowState,detailPage } = store.getState().meetingReducer || [];

  const [tabKey, setTabKey] = useState('2');
  let history = useHistory();
  useEffect(() => {
    if(!_.isEmpty(detailPage))setTabKey('2');
  }, [detailPage.uuid,currentWindowState]);


  useEffect(() => {
   if(currentWindowState === "createMeeting") setTabKey('2')
   if(currentWindowState === "templateList") setTabKey('1')
;
  }, [currentWindowState]);

  const handleTabs = (key:any) => {
    history.push("/meeting")
  if(key === "2")
  {
      storeWindowState("createMeeting");
    }
  else {
     storeWindowState("templateList");
    }
    setTabKey(tabKey === '1' ? '2' : '1');

  }
  
  return (
    <>
    
      <div className={styles.meetingDetailsScreen}>
        <MeetingDetailsTop />
        <div className={`${styles.detailsSection} ${styles.ExtraSpace}`}>
          <Tabs activeKey={tabKey} className="meetingsTab" onChange={(e:any)=>handleTabs(e)}>
            <TabPane tab="Saved Template" key="1" >
              <SavedTemplateViewList />
            </TabPane>
            <TabPane tab="Schedule New Meeting" key="2">
              <div className={styles.scheduleNewmeet} id="meetSchedule">
                {currentWindowState === 'createMeeting' ? <MeetingSchedule />: <EditMeeting />}
                {/* <MeetingDetailsRight /> */}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
};

